import { getEnrolmentEntryUrl } from "../helpers/enrolmentJourneyHelper"

export default {
  created() {
    const prospectSwitchJourneyPages = [
      "get-a-quote",
      "elmo",
      "justmovein",
      "quote",
      "quote-personal-details"
    ]
    const websiteBeMaintenancePages = ["our-tariffs", "get-a-quote", "quote"]
    const isProspectSwitchJourneyDisabled = !this.$store.state.contentManagement
      .isProspectSwitchJourneyEnabled
    const isWebsiteBeMaintenanceEnabled = this.$store.state.contentManagement
      .isWebsiteBeMaintenanceEnabled

    const route = this.$nuxt.$route.name

    const redirectToQuoteMaintenance =
      isProspectSwitchJourneyDisabled &&
      prospectSwitchJourneyPages.includes(route)

    const redirectToMaintenancePage =
      isWebsiteBeMaintenanceEnabled && websiteBeMaintenancePages.includes(route)

    if (redirectToQuoteMaintenance) {
      return this.$router.push(getEnrolmentEntryUrl())
    } else if (redirectToMaintenancePage) {
      return this.$router.push("/maintenance/")
    }
  }
}
